import { render, staticRenderFns } from "./ContactLensEdit.vue?vue&type=template&id=1e995ef2&"
import script from "./ContactLensEdit.vue?vue&type=script&lang=js&"
export * from "./ContactLensEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports